import React from 'react';
import {
  Container, Row, Card, CardBody, Table
} from 'reactstrap';
import Slider from 'react-slide-out';
import FormComponent from "../form";
import 'react-slide-out/lib/index.css';
import { Link } from "react-router-dom";
import client from "../../../../shared/api-client";
import Modal from "../../../../shared/modal";
import * as validate from "../../../../shared/validate";

class RoleCommon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      roles: [],
      show: false,
      formValues: []
    };
  }

  componentDidMount() {
    this.getRoles();
  }

  getRoles = () => {
    client(`admin_roles.php`).then((response) => this.setState({roles: response.data}));
  }

  toggleAddNewMembers = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  }

  handleForm = (formValues) => {
    formValues.role_name = formValues.role_name.trim();

    this.setState({ formValues }, () => {
      // Validations will be added here if required frontend validations
    });
  }

  showModal = e => {
    this.setState({
      show: !this.state.show
    });
  };

  addRole = () => {

    let errors = [];

    if (this.state.formValues.role_name === undefined 
      || !validate.required(this.state.formValues.role_name)
      || !validate.name(this.state.formValues.role_name)) {
      errors.push('Please enter a valid role name.');
    } else {
      let rolesMatched = this.state.roles.filter(role => role.role.toLowerCase().trim() === this.state.formValues.role_name.toLowerCase().trim());

      if (rolesMatched.length > 0) {
        errors.push('Role name already exists.');
      }
    }

    if (errors.length > 0) {
      this.setState({show: true, errors: errors, success: ''});
      return false;
    }

    let method = "PUT";
    client(`admin_roles.php`, {
      method: method,
      body: this.state.formValues,
    }).then(
      (response) => {
        this.getRoles();
        this.setState({isOpen: false, show: true, errors: [], success: response._user_message});
      },
      (error) => {
        this.setState({show: true, errors: error._user_message, success: ''});
      }
    );
  }

  render() {
    return (
      <React.Fragment>
      <Container>
        <Row className="user-section">
          <Card className="">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">{this.props.title}</h5>
                <div className="toolbar-buttons">
                  <button type="button" onClick={() => this.setState({formValues: []}, () => this.toggleAddNewMembers())} className="btn btn-sm btn-primary">Add Role</button>
                </div>
              </div>
              <Table responsive hover className="table--head-accent table--bordered">
                <thead>
                  <tr>
                    <th>Role</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody className="table--members">
                  {this.state.roles.map(data => (
                    <tr key={data.rid}>
                      <td>
                        <p>{data.role}</p>
                      </td>
                      <td>
                        <Link to={() => { return `/permissions/${data.rid}` }} >
                          Manage Permissions
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Row>
        <Slider
          isOpen={this.state.isOpen}
          footer={(
            <div className="button-container">
              <button className="square btn btn-primary btn-sm" onClick={() => this.addRole()} type="button">Submit</button>
              <button type="button" className="square btn btn-danger btn-sm" onClick={() => this.toggleAddNewMembers()}>
                Cancel
              </button>
            </div>
          )}
          onOutsideClick={() => this.setState({ isOpen: false })}
        >
          <FormComponent title="Add Role" 
            handleForm={(formValues) => this.handleForm(formValues)} 
            toggleAddNewMembers={this.toggleAddNewMembers} />
        </Slider>
      </Container>
      <Modal onClose={this.showModal} show={this.state.show} errors={this.state.errors} success={this.state.success}>
        </Modal>
      </React.Fragment>
    );
  }
}

export default RoleCommon;
